import * as React from "react";

function WandMagicSparklesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M248.8 4.994C249.9 1.99 252.8 0 256 0s6.1 1.99 7.2 4.994l14.1 37.676L315 56.79c3 1.13 5 4 5 7.21s-2 6.08-5 7.21l-37.7 14.12L263.2 123c-1.1 3-4 5-7.2 5s-6.1-2-7.2-5l-14.1-37.67-38.6-14.12c-3-1.13-4.1-4-4.1-7.21s1.1-6.08 4.1-7.21l38.6-14.12 14.1-37.676zm246.5 9.066 34.6 34.58c18.7 18.74 18.7 49.14 0 67.86L148.5 497.9c-18.7 18.7-49.12 18.7-67.86 0l-34.58-34.6c-18.75-18.7-18.75-49.1 0-67.9L427.4 14.06c18.8-18.746 49.2-18.746 67.9 0zM461.4 48 351.7 157.7l34.5 34.6L495.1 82.58 461.4 48zM114.6 463.1l237.7-236.9-34.6-34.5L80 429.4l34.6 33.7zM7.491 117.2 64 96l21.19-56.51C86.88 34.98 91.19 32 96 32c4.8 0 9.1 2.98 10.8 7.49L128 96l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8 0 4.8-3 9.1-7.5 10.8L128 160l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5-4.81 0-9.12-3-10.81-7.5L64 160 7.491 138.8C2.985 137.1 0 132.8 0 128c0-4.8 2.985-9.1 7.491-10.8zm352.009 256L416 352l21.2-56.5c1.7-5.4 6-7.5 10.8-7.5 4.8 0 9.1 2.1 10.8 7.5L480 352l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8 0 4.8-3 9.1-7.5 10.8L480 416l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5-4.8 0-9.1-3-10.8-7.5L416 416l-56.5-21.2c-5.4-1.7-7.5-6-7.5-10.8 0-4.8 2.1-9.1 7.5-10.8z"
  }));
}

const ForwardRef = React.forwardRef(WandMagicSparklesIcon);
export default ForwardRef;